import { tokenAliasOrValue } from "./base";
import { BorderWidthTokenData } from "./border-width";
import { ColorTokenData } from "./color";
import { z } from "zod";
export const BorderPosition = z.enum(["Inside", "Center", "Outside"]);
export const BorderStyle = z.enum(["Dashed", "Dotted", "Solid", "Groove"]);
export const BorderValue = z.object({
    color: ColorTokenData,
    width: BorderWidthTokenData,
    position: BorderPosition,
    style: BorderStyle.optional(),
});
export const BorderTokenData = tokenAliasOrValue(BorderValue);
